import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { unsubscribeAction } from "@redux/modules/subscription/slices";
import { Link } from "react-router-dom";
import { ConfirmModal } from "@components/ConfirmModal";
import styles from "./styles/InstructorCard.module.css";
import { formatNumberText } from "@helpers";
import { replaceErrorAvatar } from "@helpers";

const InstructorCard = ({ data, className, variant }) => {
  const {
    fullName,
    id,
    headLine,
    avatarUrl,
    facebookLink,
    linkedlnLink,
    youtubeLink,
    totalSubcripbers,
    totalCourses,
  } = data;
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.user);
  const handleUnsubscribe = (userId) => {
    dispatch(unsubscribeAction(userId));
  };

  return (
    <div
      className={clsx(
        styles.instructorCard,
        className,
        "d-flex flex-column justify-content-between p-4 rounded border"
      )}
    >
      <div className="content">
        <div className={clsx(styles.tutorImg, "mb-2")}>
          <Link
            to={
              profile.data?.id === id
                ? "/my-profile-view"
                : `/instructor-profile-view/${id}`
            }
          >
            <img
              src={avatarUrl}
              alt="avatar"
              className="m-auto"
              onError={replaceErrorAvatar}
            />
          </Link>
        </div>
        <div className="details">
          <Link
            to={
              profile.data?.id === id
                ? "/my-profile-view"
                : `/instructor-profile-view/${id}`
            }
            className="tutor_name fw-bold text-decoration-none"
          >
            {fullName}
          </Link>
        </div>
        <div className="fs-6 text-truncate">{headLine}</div>
      </div>
      <div>
        <div>
          {variant == "subscribed" ? (
            <div className="subscribed my-2">
              <ConfirmModal
                onSubmit={() => handleUnsubscribe(id)}
                title="Confirm Unsubscribe"
                body="Do you really want to unsubscribe this instructor"
                submitButton="Submit"
              >
                <Button
                  className="text-white"
                  // onClick={() => handleUnsubscribe(id)}
                >
                  Subscribed
                </Button>
              </ConfirmModal>
            </div>
          ) : (
            <ul
              className={clsx(
                styles.listIcon,
                "d-flex list-unstyled justify-content-center mb-3 mt-3"
              )}
            >
              {facebookLink && (
                <li className={clsx(styles.iconSocial)}>
                  <a href={facebookLink} rel="noreferrer" target="_blank">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </li>
              )}
              {linkedlnLink && (
                <li className={clsx(styles.iconSocial, "bg-info")}>
                  <a href={linkedlnLink} rel="noreferrer" target="_blank">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </li>
              )}
              {youtubeLink && (
                <li className={clsx(styles.iconSocial, "bg-danger")}>
                  <a href={youtubeLink} rel="noreferrer" target="_blank">
                    <i className="fab fa-youtube"></i>
                  </a>
                </li>
              )}
            </ul>
          )}
        </div>
        <div className={clsx(styles.info)}>
          <span className="mr-2">
            {formatNumberText(totalSubcripbers, "Subscriber")}
          </span>
          <span className="">{formatNumberText(totalCourses, "Course")}</span>
        </div>
      </div>
    </div>
  );
};

/* required: display name */
InstructorCard.displayName = "InstructorCard";

/* required: props types */
InstructorCard.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
};

/* required: default props */
InstructorCard.defaultProps = {};

export { InstructorCard };
